type EventFrame = {
    id?: number;
    time: number;
};

type PlayableEvent = {
    type?: 'OBJECT' | 'SCENE';
    startTime?: number;
    frames?: EventFrame[];
};

export function getEventPlaybackStartTime(
    event: PlayableEvent,
    focuses?: number[][],
): number {
    if (event.type === 'SCENE') {
        return event.startTime ?? 0;
    }
    return getEventStartTime(event.frames, focuses);
}

export function getEventStartTime(
    frames: EventFrame[] | undefined,
    focuses?: number[][],
): number {
    const firstFocusFrameId = focuses?.[0]?.[0];
    if (firstFocusFrameId !== undefined) {
        const focusTime = frames?.find(
            (frame) => frame.id === firstFocusFrameId,
        )?.time;
        if (focusTime !== undefined) return focusTime;
    }
    return frames && frames.length > 0 ? frames[0].time : 0;
}
